import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';
import {
	OperationResult,
	UpgradeExecuteRequest,
	UpgradeExecuteResponse,
} from '../../../admin/components/tools/UpgradeWizard/types';

export function useExecuteUpgradeMutation() {
	const userSession = useAdminUserSession();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (request: UpgradeExecuteRequest) => {
			const response = await userSession.webServiceHelper.callAsync<OperationResult<UpgradeExecuteResponse>>(
				'admin/BillingUtilities/ExecuteSubscriptionUpgrade',
				'POST',
				request
			);

			// Handle both wrapped response { success, value } and unwrapped response
			if ('value' in response && 'success' in response) {
				if (!response.success || !response.value) {
					throw new Error(response.error || 'Failed to execute upgrade');
				}
				return response.value;
			}

			return response as unknown as UpgradeExecuteResponse;
		},
		onSuccess: (_data, variables) => {
			// Invalidate the subscription state query to refresh data
			queryClient.invalidateQueries({
				queryKey: ['subscriptionState', variables.accountId],
			});
		},
	});
}
